import supabase from '../supabase/supabase';

const MEDIA_TABLE = 'zevi_product_media_20260925';

function cleanMedia(media) {
  return (media || [])
    .map((item) => ({
      ...item,
      media_url: String(item.media_url || '').trim()
    }))
    .filter((item) => item.media_url);
}

export function mapProductColors(variants = [], media = [], inventory = []) {
  return variants
    .filter((variant) => variant.color || variant.attributes?.color)
    .map((variant) => {
      const variantMedia = media
        .filter((item) => item.variant_id === variant.id)
        .sort((first, second) => (
          Number(first.sort_order || 0) - Number(second.sort_order || 0)
        ));

      const stock = inventory.find(
        (item) => item.variant_id === variant.id
      );

      return {
        id: variant.id,
        variant_id: variant.id,
        name:
          variant.color
          || variant.attributes?.color
          || variant.name,
        hex:
          variant.color_hex
          || variant.attributes?.color_hex
          || '#c99a45',
        quantity: Number(stock?.quantity_on_hand || 0),
        image_url: variantMedia[0]?.media_url || '',
        media: variantMedia.map((item) => ({ ...item }))
      };
    });
}

export async function replaceVariantMedia({
  productId,
  productName,
  variantId,
  colorName,
  media
}) {
  const { error: removeError } = await supabase
    .from(MEDIA_TABLE)
    .delete()
    .eq('product_id', productId)
    .eq('variant_id', variantId);

  if (removeError) {
    throw new Error(`Media for ${colorName} could not be updated.`);
  }

  const validMedia = cleanMedia(media);

  if (validMedia.length === 0) {
    return;
  }

  const rows = validMedia.map((item, index) => ({
    product_id: productId,
    variant_id: variantId,
    media_url: item.media_url,
    media_type: item.media_type === 'video' ? 'video' : 'image',
    alt_text: `${productName} - ${colorName} - ${
      item.media_type === 'video' ? 'video' : 'view'
    } ${index + 1}`,
    is_primary: index === 0,
    sort_order: index
  }));

  const { error } = await supabase
    .from(MEDIA_TABLE)
    .insert(rows);

  if (error) {
    throw new Error(`Media for ${colorName} could not be saved.`);
  }
}